<template lang="pug">
v-container
  v-card
    v-card-text
      v-layout(wrap)
        v-flex(xs12 sm6)
          v-text-field(label="CSV Header" :error="csvHeaderRows.errors.length > 0" :hint="csvHeader ? csvHeaderRows.errors.length ? `Unbekannte spalten: ${csvHeaderRows.errors.join(', ')}` : `${csvHeaderRows.rows.length} Spalten: ${csvHeaderRows.rows.join(', ')}` : 'csv header zeile hier einfügen'" persistent-hint v-model="csvHeader" :error-messages="gqlErrorsFor('inventarCreate', 'csv')")
          v-textarea(label="CSV" v-if="csvHeader" :error="csvRows[0] && csvRows[0].length != csvHeaderRows.rows.length" :hint="csv ? csvRows[0] && (csvRows[0].length == csvHeaderRows.rows.length) ? `${csvRows.length} Zeilen, ${csvRows[0] && csvRows[0].length || 0} Spalten` : `${csvRows[0] && csvRows[0].length || 0} Spalten aber ${csvHeaderRows.rows.length} Spalten erwartet` : 'zum Header passende CSV Zeile'" persistent-hint v-model="csv" :error-messages="gqlErrorsFor('inventarCreate', 'csv')")
          v-combobox(label="Geräteart" :items="geraetearten" v-model="edit.art" :error-messages="gqlErrorsFor('inventarCreate', 'art')")
          v-combobox(label="Hersteller" :items="herstellers" v-model="edit.hersteller" :error-messages="gqlErrorsFor('inventarCreate', 'hersteller')")
          v-text-field(label="Model" v-model="edit.model" :error-messages="gqlErrorsFor('inventarCreate', 'model')")
          v-text-field(label="Seriennr." v-model="edit.seriennr" :error-messages="gqlErrorsFor('inventarCreate', 'seriennr')")
          v-text-field(label="IMEI" v-model="edit.imei" :error-messages="gqlErrorsFor('inventarCreate', 'imei')")
          v-combobox(label="Gekauft von Firma" :items="laeden" v-model="edit.laden" :error-messages="gqlErrorsFor('inventarCreate', 'laden')")
          input-date(label="Kaufdatum" v-model="edit.kaufdatum" :error-messages="gqlErrorsFor('inventarCreate', 'kaufdatum')")
          v-combobox(label="Zustand" :items="zustaende" v-model="edit.zustand" :error-messages="gqlErrorsFor('inventarCreate', 'zustand')")
          v-btn(@click="save" :loading="loading > 0" :disabled="!editChanged") Speichern
          v-btn(@click="csvImport" :loading="loading > 0" :disabled="!editChanged || csvImportLine >= 0" v-if="csvRows.length > 1") CSV Import

        v-flex(xs12 sm6)
          .text-xs-center(@click="downloadQrcode" ref="qrcode" :style="editChanged ? 'display: none' : ''")
          .text-xs-center(v-if="csvImportLine >= 0") CSV Zeile: {{csvImportLine}}
          .text-xs-center(v-else-if="csvImportList"): pre {{csvImportList}}

</template>


<script>
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'
import QRCodeStyling from "@nimashoghi/qr-code-styling"
let qrCodeEl = null
import { isEqual } from 'lodash'
import moment from 'moment'
window.m=moment

export default {
  props: ['extra'],
  mixins: [GraphqlErrorObject],
  data() {
    return {
      loading: 0,
      csvImportLine: -1,
      csvHeader: "",
      csv: "",
      csvImportList: '',
      csvMap: {
        'geräteart': 'art',
        'hersteller': 'hersteller',
        'modell': 'model',
        'seriennummer': 'seriennr',
        'imei': 'imei',
        'gekauft von firma': 'laden',
        'kaufdatum': 'kaufdatum',
        'zustand': 'zustand',
      },
      editOld: {},
      edit: {
        art: '',
        hersteller: '',
        model: '',
        seriennr: '',
        imei: '',
        laden: '',
        kaufdatum: null,
        zustand: '',
      },
      qrcode: "",
      zustaende: [
        "A-Ware",
        "B-Ware",
        "Neu",
      ],
      herstellers: [
        "Lenovo",
        "Logitech",
        "Iiyama",
        "Xiaomi",
        "Samsung",
        "Microsoft",
      ],
      laeden: [
        "Cyberport",
        "Mediamarkt",
        "Saturn",
        "LapStore",
        "AFB",
        "EMS",
        "Think-Store",
        "Amazon",
        "Harlander",
      ],
      geraetearten: [
        "Laptop",
        "Tablet",
        "Handy",
        "Drucker",
        "Monitor",
        "Desktop PC",
        "Server",
        "Switch",
        "Access Point",
        "Dockingstation",
        "Zubehör",
      ]
    }
  },
  mounted() {
    qrCodeEl = new QRCodeStyling()
    qrCodeEl.append(this.$refs.qrcode)
    this.$nextTick(this.updateQrCode)
  },
  beforeDestroy() {
    qrCodeEl = null
  },
  watch: {
    qrcode() {
      this.updateQrCode()
    },
    csvRows(csvRows) {
      this.edit = this.csvLineData(0, csvRows)
    },
  },
  computed: {
    editChanged() {
      return !isEqual(this.edit, this.editOld)
    },
    csvSeperator() {
      const csvHeader = this.csvHeader || ''
      const tabs = csvHeader.split("\t").length
      const semi = csvHeader.split(";").length
      const coma = csvHeader.split(",").length
      if (tabs >= semi && tabs >= coma) {
        return "\t"
      } else if (semi >= tabs && semi >= coma) {
        return ";"
      } else {
        return ","
      }
    },
    csvHeaderRows() {
      const csvHeader = (this.csvHeader || '')
      const csvMap = this.csvMap
      if (csvHeader) {
        const rows = csvHeader.split(this.csvSeperator)
        const errors = rows.filter((d) => !csvMap[d.toLowerCase()])
        const mapping = rows.map((d) => csvMap[d.toLowerCase()]).filter((d) => d)
        return { rows, errors, mapping }
      } else {
        return { rows: [], errors: [] }
      }
    },
    csvRows() {
      const csv = this.csv
      if (csv) {
        return csv.split(/\r?\n/).map((r) => r.split(this.csvSeperator))
      } else {
        return []
      }
    }
  },
  methods: {
    csvLineData(line, csvRows) {
      const edit = {}
      const header = this.csvHeaderRows.mapping
      const rows = csvRows[line] || []
      const csvMap = this.csvMap
      Object.values(csvMap).forEach((row) => {
        edit[row] = ''
      })
      header.forEach((row, i) => {
        if (rows[i] != null) {
          if (row == 'kaufdatum') {
            const date = moment(rows[i])
            edit[row] = date.format("YYYY-MM-DD")
          } else {
            edit[row] = rows[i].replace(/ /g, '')
          }
        } else {
          edit.error = true
        }
      })
      return edit
    },
    importStep() {
      if (this.csvImportLine >= 0) {
        setTimeout(() => {
          if (this.csvImportLine < this.csvRows.length) {
            while (this.csvImportLine < this.csvRows.length) {
              this.edit = this.csvLineData(this.csvImportLine, this.csvRows)
              if (!this.edit.error) {
                console.log(`Import line ${this.csvImportLine + 1}`)
                this.save()
                break
              } else {
                console.log(`Skipping line ${this.csvImportLine + 1}`)
                this.csvImportLine++
              }
            }
          }
          if (this.csvImportLine >= this.csvRows.length) {
            console.log("Import finished")
            this.csvImportLine = -1
          }
        }, 0)
      }
    },
    downloadQrcode() {
      qrCodeEl.download({ name: `HVD-QR-${this.qrcode}`, skipDownload: false })
      this.importStep()
    },
    updateQrCode() {
      if (!qrCodeEl) {
        return
      }
      const h = 360
      const w = 320
      const m = 5
      qrCodeEl.update({
        width: w,
        height: h,
        margin: m,
        data: this.qrcode ? `https://box.hvd-bb.de/inventar/${this.qrcode}` : '',
        image: require("../../../../app/assets/images/logo-x-qr.svg"),
        errorCorrectionLevel: "H",
        dotsOptions: {
          color: "#000",
          type: "square"
        },
        backgroundOptions: {
          color: "#fff",
        },
        imageOptions: {
          crossOrigin: "anonymous",
          margin: 0,
          imageSize: 0.4,
          hideBackgroundDots: false,
        }
      })

      if (qrCodeEl._drawingPromise) {
        qrCodeEl._drawingPromise.then(() => {
          const ctx = qrCodeEl._canvas.getCanvas().getContext("2d")
          ctx.save()
          ctx.drawImage(ctx.canvas, 0, -(h-w)/2)
          ctx.font = "42px monospace"
          ctx.textAlign = "center"
          ctx.fillStyle = "#000000"
          ctx.fillText(this.qrcode, w/2, h-m*2.5, w-2*m)
          ctx.restore()
        })
      }
    },
    csvImport() {
      this.csvImportLine = 0
      this.csvImportList = 'UID;Seriennr.\n'
      this.importStep()
    },
    save() {
      if (this.loading > 0 || !this.editChanged) {
        return
      }
      this.loading++
      this.$apollo.mutate({
        mutation: gql`mutation NeuesGeraetHinzufuegenVueSave(
          $art: String
          $hersteller: String
          $model: String
          $seriennr: String
          $imei: String
          $laden: String
          $kaufdatum: Date
          $zustand: String
        ) {
          inventarCreate(
            art: $art
            hersteller: $hersteller
            model: $model
            seriennr: $seriennr
            imei: $imei
            laden: $laden
            kaufdatum: $kaufdatum
            zustand: $zustand
          ) {
            uid
          }
        }`,
        variables: this.edit,
      }).then((response) => {
        this.qrcode = response.data.inventarCreate.uid
        this.editOld = { ...this.edit }
        this.loading--
        if (this.csvImportLine >= 0) {
          this.csvImportList += `${this.qrcode};${this.edit.seriennr}\n`
          this.csvImportLine++
        }
      }).catch((error) => {
        this.gqlAddErrors(error)
        this.loading--
      })
    },
  },
}
</script>
